/*
 * @Descripttion:
 * @version:
 * @Author: Raoxf
 * @Date: 2022-05-28 22:05:38
 * @LastEditors: Raoxf
 * @LastEditTime: 2022-12-29 21:19:05
 */

export default (Vue) => {
  return [
    {
      title: "联系人",
      key: "userName",
      align: 'center'
    },
    {
      title: "手机号",
      key: "phone",
      align: 'center',
    },
    {
      title: "技能备注",
      key: "remark",
      align: 'center'
    },
    {
      title: "审核状态",
      key: "reviewStatus",
      align: 'center',
      render: (h, { row }) => {
        const statusMap = {
          0: { text: '待审核', color: '#E6A23C' },
          1: { text: '已通过', color: '#67C23A' },
          2: { text: '已拒绝', color: '#F56C6C' }
        };
        const status = statusMap[row.reviewStatus] || { text: row.reviewStatus, color: '#909399' };
        return h('span', {
          style: {
            color: status.color
          }
        }, status.text);
      }
    },
    {
      title: "拒绝原因",
      key: "reason",
      align: 'center',
      render: (h, { row }) => {
        return h('div', row.reviewStatus == 2 ? row.reason : '-')
      }
    },
    {
      title: "类型",
      key: "type",
      align: 'center',
      render: (h, { row }) => {
        return h('div', row.type == 1 ? '服务商' : '保洁员')
      }
    },
    {
      title: "创建时间",
      key: "createDt",
      align: 'center'
    },
    {
      title: "操作",
      key: "action",
      align: 'center',
      width: 150,
      render: (h, { row }) => {
        return h('div', [
          h('el-button', {
            props: {
              type: 'text',
              size: 'small'
            },
            on: {
              click: () => {
                Vue.openReviewDialog(row);
              }
            }
          }, '审核')
        ])
      }
    },
  ]
}